import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { QUERY_KEYS } from 'constants/common';
import { AppointmentService } from 'services/appointments';
import { useEnterpriseId } from 'stores/user';

const REFETCH_INTERVAL_MS = 60_000;

export const useFetchReportNotificationsCount = (enabled = true): UseQueryResult<number, Error> => {
  const enterpriseId = useEnterpriseId();

  return useQuery({
    queryKey: [QUERY_KEYS.FETCH_REPORT_NOTIFICATIONS_COUNT, enterpriseId, false],
    queryFn: () =>
      AppointmentService.getReportNotificationsCount(enterpriseId, { verified: false }),
    select: response => response.data.count,
    enabled: !!enterpriseId && enabled,
    refetchInterval: REFETCH_INTERVAL_MS,
  });
};
